export const translations = {
  households: {
    Default: 'Domyślne',
    title: 'Gospodarstwa domowe',
    members: 'Członkowie',
    owner: 'Właściciel',
    member: 'Członek',
    inviteUser: 'Zaproś użytkownika',
    householdName: 'Nazwa gospodarstwa',
    emailAddress: 'Adres email',
    emailPlaceholder: 'Wprowadź adres email użytkownika',
    expiryDays: 'Dni ważności',
    sendInvitation: 'Wyślij zaproszenie',
    sending: 'Wysyłanie...',
    invitationSent: 'Zaproszenie zostało wysłane',
    invitationFailed: 'Nie udało się wysłać zaproszenia',
    enterHousehold: 'Wejdź do gospodarstwa',
    noHouseholds: 'Brak gospodarstw domowych',
    switchedToHousehold: 'Przełączono na gospodarstwo domowe',
    addMember: 'Zaproś',
    enter: 'Wejdź',
    leave: 'Opuść',
    removeMember: 'Usuń',
    confirmRemoveMemberTitle: 'Usunięcie członka',
    confirmRemoveMemberMessage: 'Czy na pewno chcesz usunąć tego członka z gospodarstwa domowego?',
    confirmLeaveTitle: 'Opuszczenie gospodarstwa',
    confirmLeaveMessage: 'Czy na pewno chcesz opuścić to gospodarstwo domowe?',
    featureNotReady: 'Funkcja jest jeszcze niegotowa i wdrożymy ją wkrótce. Jeśli koniecznie chcesz użyć tej akcji, skontaktuj się z support@listum.pl',
    createHousehold: 'Utwórz gospodarstwo',
    householdNameLabel: 'Nazwa gospodarstwa',
    householdNamePlaceholder: 'Np. Moja rodzina',
    createHouseholdTitle: 'Utwórz nowe gospodarstwo domowe',
    creating: 'Tworzenie...',
    householdCreated: 'Gospodarstwo domowe zostało utworzone',
    householdCreationFailed: 'Nie udało się utworzyć gospodarstwa domowego',
    householdLeft: 'Opuściłeś gospodarstwo domowe',
    leaveFailed: 'Nie udało się opuścić gospodarstwa domowego',
    memberRemoved: 'Członek został usunięty z gospodarstwa',
    removeFailed: 'Nie udało się usunąć członka',
    deleteHousehold: 'Usuń',
    confirmDeleteTitle: 'Usunięcie gospodarstwa',
    confirmDeleteMessage: 'Czy na pewno chcesz usunąć to gospodarstwo domowe? Ta operacja jest nieodwracalna.',
    householdDeleted: 'Gospodarstwo domowe zostało usunięte',
    deleteFailed: 'Nie udało się usunąć gospodarstwa domowego',
    nameUpdated: 'Nazwa gospodarstwa została zaktualizowana',
    updateFailed: 'Nie udało się zaktualizować nazwy gospodarstwa',
    nameRequired: 'Nazwa gospodarstwa jest wymagana',
  },
  common: {
    loading: 'Ładowanie...',
    continue: 'Kontynuuj',
    cancel: 'Anuluj',
    select: 'Wybierz',
    save: 'Zapisz',
    saving: 'Zapisywanie...',
    add: 'Dodaj',
    create: 'Utwórz',
    close: 'Zamknij',
    error: 'Błąd',
    success: 'Sukces',
    deleting: 'Usuwanie...',
    delete: 'Usuń',
    offline: 'Brak internetu',
    validationError: 'Błąd walidacji'
  },
  products: {
    title: 'Produkty',
    addProduct: 'Dodaj produkt',
    editProduct: 'Edytuj produkt',
    deleteProduct: 'Usuń produkt',
    productName: 'Nazwa produktu',
    unit: 'Jednostka',
    category: 'Kategoria',
    noCategories: 'Brak kategorii',
    noProducts: 'Brak produktów',
    deleteConfirm: 'Czy na pewno chcesz usunąć ten produkt?',
    deleteSuccess: 'Produkt został usunięty',
    deleteFailed: 'Nie udało się usunąć produktu',
    loadFailed: 'Nie udało się pobrać danych',
    selectProduct: 'Wybierz produkt',
    createNewProduct: 'Utwórz nowy produkt',
  },
  householdSelector: {
    title: 'Wybór gospodarstwa domowego',
    subtitle: 'Wybierz gospodarstwo domowe, w którym chcesz zarządzać listami zakupów',
    loadingHouseholds: 'Ładowanie gospodarstw domowych...'
  },
  categories: {
    none: 'Brak',
    fruits: 'Owoce',
    vegetables: 'Warzywa',
    herbs: 'Zioła',
    dairy_eggs: 'Nabiał i jaja',
    meat_deli_fish: 'Mięso, wędliny i ryby',
    bakery: 'Pieczywo',
    dry_goods: 'Produkty sypkie',
    canned_preserved: 'Przetwory i konserwy',
    spices_condiments: 'Przyprawy i dodatki',
    snacks_sweets: 'Słodycze i przekąski',
    beverages: 'Napoje',
    alcohol: 'Alkohole',
    frozen: 'Mrożonki',
    cleaning: 'Środki czystości',
    hygiene: 'Artykuły higieniczne',
    baby: 'Dla dzieci',
    pets: 'Dla zwierząt',
    household_industrial: 'Artykuły domowe i przemysłowe',
    health_beauty: 'Zdrowie i uroda',
    other: 'Inne',
    ready_meals: 'Dania gotowe',
    vege: 'Vege',
    electronics: 'Elektronika',
    press_and_books: 'Prasa i książki',
    automotive: 'Motoryzacja',
    coffee_and_tea: 'Kawy i herbaty',
    clothing_and_footwear: "Odzież i obuwie"
  },
  units: {
    bag: 'torb.',
    bottle: 'but.',
    box: 'pudeł.',
    can: 'pusz.',
    dozen: 'tuz.',
    gram: 'g.',
    jar: 'słoik',
    kilogram: 'kg',
    liter: 'l.',
    loaf: 'boch.',
    milliliter: 'ml',
    pack: 'opak.',
    package: 'paczk.',
    piece: 'szt.',
    slice: 'plaster',
    tube: 'tubka',
    bunch: 'pęczek'
  },
  shoppingLists: {
    title: 'Listy zakupów',
    active: 'Aktywne',
    templates: 'Szablony',
    archived: 'Archiwalne',
    noActiveLists: 'Brak aktywnych list zakupów',
    noTemplates: 'Brak szablonów',
    noArchivedLists: 'Brak archiwalnych list',
    loadFailed: 'Nie można załadować list zakupów',
    emptyList: 'Lista jest pusta',
    addProduct: 'Dodaj produkt',
    addList: 'Dodaj listę zakupów',
    listName: 'Nazwa listy',
    markUnavailable: 'Oznacz jako niedostępny',
    removeProduct: 'Usuń produkt',
    markAsBought: 'Oznacz jako kupiony',
    quantity: 'Ilość',
    comment: 'Komentarz',
    commentPlaceholder: 'Dodaj opcjonalny komentarz...',
    checkedOff: 'Odhaczone',
    completeList: 'Zakończ zakupy',
    reopenList: 'Przywróć',
    useTemplate: 'Użyj szablonu',
    useAsTemplate: 'Szablon',
    removeTemplate: 'Usuń szablon',
    productName: 'Nazwa produktu',
    editProduct: 'Edytuj produkt',
    nameUpdated: 'Nazwa listy została zaktualizowana',
    listCompleted: 'Lista zakupów została zamknięta',
    showOlder: 'Pokaż starsze',
    deleteList: 'Usuń',
    listDeleted: 'Lista zakupów została usunięta',
    copyList: 'Kopiuj',
    copying: 'Dane skopiowanej listy',
    toggleGestureMode: 'Przełącz sterowanie gestami',
    confirmDeleteTitle: 'Potwierdzenie usunięcia',
    confirmDeleteMessage: 'Czy na pewno chcesz usunąć tę listę? Ta operacja jest nieodwracalna.',
    changeQueuedForLater: 'Zmiany zostaną wysłane gdy odzyskasz połączenie z internetem',
    addMultipleProducts: 'Dodaj wiele',
    addMultipleProductsTitle: 'Dodaj wiele produktów',
    selectProducts: 'Wybierz produkty',
    searchProducts: 'Szukaj produktów...',
    clearSearch: 'Wyczyść wyszukiwanie',
    selectedProducts: 'Wybrane produkty',
    noProductsFound: 'Nie znaleziono produktów',
    productsAdded: 'Produkty zostały dodane do listy',
    selectAtLeastOneProduct: 'Wybierz przynajmniej jeden produkt',
    addProductsFailed: 'Nie udało się dodać produktów',
    alreadyAdded: 'dodany'
  },
  auth: {
    loginFailed: 'Nie udało się zalogować',
    invalidCredentials: 'Nieprawidłowy email lub hasło',
    invalidLoginData: 'Nieprawidłowe dane logowania',
    serverError: 'Błąd serwera. Spróbuj ponownie później',
    connectionError: 'Nie można połączyć się z serwerem',
    refreshTokenExpired: 'REFRESH_TOKEN_EXPIRED',
    refreshFailed: 'Nie udało się odświeżyć sesji',
    registrationFailed: 'Nie udało się zarejestrować',
    validationError: 'Błąd walidacji danych',
    invalidRegistrationData: 'Nieprawidłowe dane rejestracji',
    recaptchaFailed: 'ReCaptcha nie została jeszcze załadowana',
    recaptchaNotConfigured: 'ReCaptcha site key is not configured',
    activationFailed: 'Nie udało się aktywować konta',
    forgotPasswordFailed: 'Nie udało się wysłać żądania resetowania hasła',
    resetPasswordFailed: 'Nie udało się zresetować hasła',
    invalidOrExpiredResetLink: 'Link resetujący hasło jest nieprawidłowy lub wygasł',
  },
  apiErrors: {
    user_with_given_email_already_exists: 'Użytkownik z podanym adresem email już istnieje',
    'Invalid credentials.': 'Nieprawidłowy email lub hasło',
    'ReCaptcha verification failed': 'Weryfikacja ReCaptcha nie powiodła się',
    invalid_or_expired_reset_password_reques: 'Link resetujący hasło jest nieprawidłowy lub wygasł',
    invalid_or_expired_reset_password_request: 'Link resetujący hasło jest nieprawidłowy lub wygasł',
  },
  apiMessages: {
    user_registered_check_email: 'Użytkownik został zarejestrowany. Sprawdź swoją skrzynkę email, aby aktywować konto.',
  },
  register: {
    title: 'Zarejestruj się',
    email: 'Email',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    password: 'Hasło',
    passwordConfirmation: 'Potwierdź hasło',
    passwordHint: 'Minimum 8 znaków, wielka i mała litera, cyfra oraz znak specjalny (@$!%*?&)',
    submitButton: 'Zarejestruj się',
    submitting: 'Rejestrowanie...',
    hasAccount: 'Masz już konto?',
    loginLink: 'Zaloguj się',
    registrationSuccess: 'Rejestracja zakończona sukcesem',
    registrationSuccessMessage: 'Użytkownik został zarejestrowany. Sprawdź swoją skrzynkę email, aby aktywować konto',
    emailRequired: 'Email jest wymagany',
    emailInvalid: 'Nieprawidłowy format email',
    firstNameRequired: 'Imię jest wymagane',
    firstNameMinLength: 'Imię musi mieć minimum 2 znaki',
    firstNameMaxLength: 'Imię może mieć maksymalnie 200 znaków',
    lastNameRequired: 'Nazwisko jest wymagane',
    lastNameMinLength: 'Nazwisko musi mieć minimum 2 znaki',
    lastNameMaxLength: 'Nazwisko może mieć maksymalnie 200 znaków',
    passwordRequired: 'Hasło jest wymagane',
    passwordMinLength: 'Hasło musi mieć minimum 8 znaków',
    passwordLowerCase: 'Hasło musi zawierać małą literę',
    passwordUpperCase: 'Hasło musi zawierać wielką literę',
    passwordDigit: 'Hasło musi zawierać cyfrę',
    passwordSpecialChar: 'Hasło musi zawierać znak specjalny (@$!%*?&)',
    passwordConfirmationRequired: 'Potwierdzenie hasła jest wymagane',
    passwordMismatch: 'Hasła nie są identyczne',
  },
  login: {
    email: 'Email',
    password: 'Hasło',
    loginButton: 'Zaloguj się',
    noAccount: 'Nie masz konta?',
    registerLink: 'Zarejestruj się',
    forgotPassword: 'Nie pamiętam hasła',
    resendActivationLink: 'Nie dotarł do mnie link aktywacyjny',
    fillAllFields: 'Proszę wypełnić wszystkie pola',
    missingData: 'Brakujące dane',
    loginSuccess: 'Zalogowano pomyślnie!',
    welcome: 'Witamy w Listum',
    unexpectedError: 'Wystąpił nieoczekiwany błąd',
    loginError: 'Błąd logowania',
  },
  activateAccount: {
    activating: 'Aktywowanie konta...',
    success: 'Konto zostało aktywowane',
    successDescription: 'Możesz teraz zalogować się do swojego konta',
    loginButton: 'Przejdź do logowania',
    error: 'Nie udało się aktywować konta',
    errorDescription: 'Sprawdź, czy link aktywacyjny jest poprawny lub skontaktuj się z administracją',
  },
  acceptInvitation: {
    accepting: 'Przetwarzanie zaproszenia...',
    success: 'Zaproszenie zostało zaakceptowane',
    successDescription: 'Zostałeś dodany do gospodarstwa domowego. Możesz teraz się zalogować.',
    loginButton: 'Przejdź do logowania',
    error: 'Nie udało się zaakceptować zaproszenia',
    userDoesntExist: 'Nie znaleziono użytkownika',
    userDoesntExistDescription: 'Aby dołączyć do gospodarstwa domowego, musisz najpierw założyć konto na adres email z zaproszenia, a następnie ponownie otworzyć ten link.',
    registerButton: 'Zarejestruj się',
    invitationInvalid: 'Zaproszenie nie istnieje lub wygasło',
    invitationInvalidDescription: 'To zaproszenie nie istnieje lub wygasło. Poproś właściciela gospodarstwa domowego o ponowne zaproszenie.',
    userAlreadyMember: 'Jesteś już członkiem tego gospodarstwa',
    userAlreadyMemberDescription: 'Już należysz do tego gospodarstwa domowego.',
  },
  forgotPassword: {
    title: 'Resetowanie hasła',
    description: 'Podaj swój adres email, a wyślemy Ci link do zresetowania hasła',
    emailRequired: 'Email jest wymagany',
    submitButton: 'Wyślij link resetujący',
    backToLogin: 'Powrót do logowania',
    emailSent: 'Email został wysłany',
    emailSentTitle: 'Sprawdź swoją skrzynkę email',
    emailSentDescription: 'Jeśli konto z podanym adresem email istnieje, wyślemy na nie link do zresetowania hasła',
    requestFailed: 'Nie udało się wysłać żądania resetowania hasła',
  },
  resetPassword: {
    title: 'Ustaw nowe hasło',
    description: 'Wprowadź nowe hasło dla swojego konta',
    newPassword: 'Nowe hasło',
    confirmPassword: 'Potwierdź nowe hasło',
    submitButton: 'Zresetuj hasło',
    backToLogin: 'Powrót do logowania',
    allFieldsRequired: 'Wszystkie pola są wymagane',
    invalidLink: 'Nieprawidłowy link resetujący',
    success: 'Hasło zostało zmienione',
    failed: 'Nie udało się zresetować hasła',
  },
  user: {
    validationError: 'Błąd walidacji danych',
    unauthorized: 'Brak autoryzacji',
    forbidden: 'Brak uprawnień',
    serverError: 'Błąd serwera. Spróbuj ponownie później',
    connectionError: 'Nie można połączyć się z serwerem',
    updateFailed: 'Nie udało się zaktualizować danych',
    updateSuccess: 'Dane zostały zaktualizowane',
    passwordResetFailed: 'Nie udało się wysłać żądania resetowania hasła',
    passwordResetSuccess: 'Link resetujący hasło został wysłany na Twój adres email',
    loadFailed: 'Nie udało się pobrać danych użytkownika',
    resendActivationFailed: 'Nie udało się wysłać linku aktywacyjnego',
  },
  accountManagement: {
    title: 'Moje konto',
    editData: 'Edycja danych konta',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    firstNameRequired: 'Imię jest wymagane',
    firstNameMinLength: 'Imię musi mieć minimum 2 znaki',
    firstNameMaxLength: 'Imię może mieć maksymalnie 200 znaków',
    lastNameRequired: 'Nazwisko jest wymagane',
    lastNameMinLength: 'Nazwisko musi mieć minimum 2 znaki',
    lastNameMaxLength: 'Nazwisko może mieć maksymalnie 200 znaków',
    saveChanges: 'Zapisz zmiany',
    changePassword: 'Zmień hasło',
    changePasswordDescription: 'Wyślemy Ci link do zmiany hasła na Twój adres email',
    deleteAccount: 'Usuń konto',
    deleteAccountTitle: 'Usunięcie konta',
    deleteAccountMessage: 'Aby usunąć konto, skontaktuj się z nami pod adresem support@listum.pl',
  },
  resendActivation: {
    title: 'Wyślij ponownie link aktywacyjny',
    description: 'Podaj swój adres email, a wyślemy Ci nowy link aktywacyjny do konta',
    emailLabel: 'Adres email',
    submitButton: 'Wyślij link aktywacyjny',
    backToLogin: 'Powrót do logowania',
    fillEmail: 'Proszę podać adres email',
    emailSent: 'Link aktywacyjny został wysłany. Sprawdź swoją skrzynkę email.',
    unexpectedError: 'Wystąpił nieoczekiwany błąd',
  },
};